import React, { useState, useEffect } from 'react';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import { useSelector } from 'react-redux';
import { buildFilters } from 'global/utils/filter';
import { get, size } from 'global/lib/lodash';
import List from '@mui/material/List';
import { EditionListItem } from './EditionListItem';
import { sortByDate } from 'global/utils';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { EditionStatus } from 'global/lib/filter';
import { Text } from 'global/components/text';
import { CenterContent } from 'global/components/perform-grid';
import { useUser } from '../../../global/hooks/useUser';
import { useFilter } from '../../../global/hooks/useFilter';

const pageSize = 50;

export default function EditionList(props) {
  const { realm } = useUser();

  const filtId = 'library.editions';

  const filter = useSelector((state) => get(state, `filter.${filtId}`));
  const fhook = useFilter();

  const [urlParams, setUrlParams] = useState({
    build: ['editions'],
    waitFor: null,
    params: {
      page: { size: pageSize, number: 1 },
      ...buildFilters(filter, { 
        includeRealm: false, 
        convertName: { searchstring: 'name', status: 'active', realm: 'realms', user_groups: 'userGroups' }, 
        dontFilter: ['courseStatus', 'start_date', 'end_date', 'edition_id', 'role', 'useLocation', 'userGroups'] 
      }),
    },
  });
  const searchString = get(filter, 'searchstring', '');

  useEffect(() => {
    setUrlParams({
      ...urlParams,
      useEffect: true,
      waitFor: undefined,
      params: {
        ...urlParams.params,
        ...{ page: { size: pageSize, number: 1 } },
        include: 'userGroups,realms',
        ...buildFilters(filter, {
          includeRealm: false,
          convertName: { searchstring: 'name', realm: 'realms', user_groups: 'userGroups' },
          dontFilter: ['courseStatus', 'start_date', 'end_date', 'edition_id', 'role', 'useLocation', 'userGroups'],
          overrideFilter: (filt) => {
            if (!filt.status) {
              filt.status = EditionStatus.map((es) => es.value).join(',');
            }
            return filt;
          },
        }),
      },
    });
  }, [filter, realm]);

  const editions = useRetrieveData({ url: `/editions` }, urlParams);

  const lastPage = get(editions, 'meta.page.last-page', null);
  const updatePage = (newPage) => {
    if (props.showCoursesInList) {
      return;
    }

    if (lastPage <= newPage) {
      setUrlParams({
        ...urlParams,
        params: {
          ...urlParams.params,
          page: { size: pageSize, number: newPage },
        },
      });
    }
  };

  const data = (() => {
    const ed = fhook.filterEditions(editions.data, { userGroups: get(filter, 'user_groups', []) });
    if (props.showCoursesInList) {
      return sortByDate([...(ed || []), ...(props.courses.data || []).filter((d) => !!d.edition).map((d) => ({ ...d, ...(d.edition || {}) }))], 'createdAt');
    }
    return sortByDate(ed || [], 'created-at');
  })();

  return (
    <CenterContent>
      <Text type="headline_small" bold>
        Reference
      </Text>
      <ListWithSearch
        {...props}
        handlePageChange={updatePage}
        currentPage={get(urlParams, 'params.page.number', 1)}
        lastPage={lastPage}
        filterString={searchString}
        loading={editions.loading}
        data={data}
        error={editions.error}
      />
    </CenterContent>
  );
}

const ListWithSearch = withInfiniteScroll(EditionListItem, List);
